/**
 * Data management exported files service
 */
angular.module("exploitation").factory("ExportedFilesService", ["$http", "ENV", function ($http, ENV) {


	/**
     * API
     */
	let api = {
		getExportedFiles: getExportedFiles
	};

	function getExportedFiles(refId) {
		return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + refId + "/files", {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	return api;
}]);
